import { connect } from 'react-redux';
import CallFlowDiagramComponent from '../../Components/CallFlows/CallFlowDiagram';
import { setCallFlows } from '../../Redux/Actions/CallFlowActions';

/**
 * Container Redux pour CallFlowDiagram
 * Connecte les données Redux nécessaires au composant
 */
const mapStateToProps = (state) => {
  return {
    st_CallFlows: state.reducer.CALL_FLOWS,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    Token: state.reducer.Token,
     WORKFLOWS: state.reducer.WORKFLOWS,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCallFlows: (callFlows) => dispatch(setCallFlows(callFlows)),
  };
};

const CallFlowDiagramContainer = connect(mapStateToProps, mapDispatchToProps)(CallFlowDiagramComponent);

export default CallFlowDiagramContainer;
